export default {
  shrink: {
    fontSize: '12px',
  }
};
